const Main = () => import ('../views/main/main.vue')
const reportQuery = () => import ('@/views/xtgl/reportQuery')
const projectNotice = () => import ('@/views/bbgl/projectNotice')
const projectResultNotice = () => import ('@/views/bbgl/projectResultNotice')
const jfck = () => import ('@/views/bbzx/jfck')
const jfckFrom = () => import ('@/views/bbzx/jfckFrom')
const zhtj = () => import ('@/views/bbzx/zhtj')
const ywyjx = () => import ('@/views/bbzx/ywyjx')
const xmyjx = () => import ('@/views/bbzx/xmyjx')
const ywyjxjs = () => import ('@/views/bbzx/ywyjxjs')
const xmyjxjs = () => import ('@/views/bbzx/xmyjxjs')
const quotationPlan = () => import('@/views/bbzx/quotationPlan')

export default [{
  path: '/bbzx',
  component: Main,
  redirect: '',
  meta: {
    title: '报表中心',
    icon: 'guide'
  },
  children: [
    {
      path: 'reportQuery',
      component: reportQuery,
      name: 'reportQuery',
      meta: { title: '报表查询', keepAlive: true }
    },
    {
      path: 'projectNotice',
      component: projectNotice,
      name: 'projectNotice',
      meta: { title: '项目公告', keepAlive: true }
    },
    {
      path: 'projectResultNotice',
      component: projectResultNotice,
      name: 'projectResultNotice',
      meta: { title: '结果公告', keepAlive: true }
    },
    {
      path: 'zhtj',
      component: zhtj,
      name: 'zhtj',
      meta: { title: '综合统计', keepAlive: true }
    },
    {
      path: 'quotationPlan',
      component: quotationPlan,
      name: 'quotationPlan',
      meta: { title: '报价计划表', keepAlive: true }
    },
    {
      path: 'jfck',
      component: jfck,
      name: 'jfck',
      meta: { title: '缴费查看', keepAlive: true }
    },
    {
      path: 'jfckFrom',
      component: jfckFrom,
      name: 'jfckFrom',
      meta: { title: '缴费查看', keepAlive: true }
    },
    {
      path: 'ywyjx',
      component: ywyjx,
      name: 'ywyjx',
      meta: { title: '业务绩效', keepAlive: true }
    },
    {
      path: 'xmyjx',
      component: xmyjx,
      name: 'xmyjx',
      meta: { title: '项目绩效', keepAlive: true }
    },
    {
      path: 'ywyjxjs',
      component: ywyjxjs,
      name: 'ywyjxjs',
      meta: { title: '业务绩效结算', keepAlive: true }
    },
    {
      path: 'xmyjxjs',
      component: xmyjxjs,
      name: 'xmyjxjs',
      meta: { title: '项目绩效结算', keepAlive: true }
    },
  ]
}]
